import React from 'react';
import '../styles/style.css';


const Preloader = () => (
  <div className="preload" data-preaload>
    <div className="circle"></div>
    <p className="text">603</p>
  </div>
);

export default Preloader;